// extracted by mini-css-extract-plugin
module.exports = {"label":"label_label__3Loe1"};